import { useContext, useEffect, useState } from 'react';
import { NavContext } from '@/components/NavContext';
import { useParams } from 'react-router';
import { CorrectionContent } from '@/components/CorrectionContent/CorrectionContent';
import CorrectionHeader from '@/components/CorrectionContent/CorrectionHeader';
import { newUid } from '@/util';
import { ActiveCourseContext } from '@/components/Contexts/ActiveCourseContext';
import { ActiveStudentContext } from '@/components/Contexts/ActiveStudentContext';
import { ActiveLessonContext } from '@/components/Contexts/ActiveLessonContext';
import { ActiveLessonStatusesContext } from '@/components/Contexts/ActiveLessonStatusesContext';
import { TEOLoader } from '@teo/components';
import { XAPIService } from '@/services/xapi.service.js';
import Cmi5, { LaunchParameters } from '@xapi/cmi5';
import { TinCanService } from '@/services/tincan.service';
import { config } from '@/config';
import { axios } from '@/axios';

const ResultPage = (props: any) => {
  const { studentId, courseId, lessonId } = useParams();
  const { setNavDisabled } = useContext(NavContext);
  const [submit, setSubmit] = useState<string | undefined>();

  const { course, setCourse } = useContext(ActiveCourseContext);
  const { student, setStudent } = useContext(ActiveStudentContext);

  const { lesson, setLesson } = useContext(ActiveLessonContext);
  const [pathnames, setPathNames] = useState<Array<string>>([]);

  const { lessonStatus, setLessonStatus } = useContext(
    ActiveLessonStatusesContext
  );
  const [preloader, setPreloader] = useState(false);
  const [preloaderNext, setPreloaderNext] = useState(false);

  useEffect(() => {
    //this fetches all pathnames
    if (lesson) {
      const mapPromises = Promise.allSettled(
        (lesson.path || '')
          .split('/')
          .slice(1, -1)
          .map((uid: any) => {
            return axios
              .get(
                `${config.backend}/directories?coursecontentId=${lesson.coursecontentId}&q=%${uid}`
              )
              .then((res) => res.data);
          })
      );

      mapPromises.then((results) => {
        try {
          const paths = (
            results.filter(
              (result) => result.status === 'fulfilled'
            ) as PromiseFulfilledResult<any>[]
          ).map((result) => {
            return result.value[0]?.name || null;
          });
          setPathNames(paths.filter((x) => !!x));
        } catch (e) {
          console.error('error', e);
        }
      });
    }
  }, [lesson]);

  const initXapi = async () => {
    const xapidetails = JSON.parse(student?.xapidetails as string);
    const xapi = XAPIService.getInstance();
    const launchParameters: LaunchParameters = {
      endpoint: xapidetails.endpoint,
      fetch: xapidetails.fetch,
      actor: xapidetails.actor,
      registration: xapidetails.registration,
      activityId: xapidetails.activityId,
    };
    try {
      xapi.cmi5 = new Cmi5(launchParameters);
      await xapi.cmi5.initialize({
        authToken: xapidetails.authToken,
        initializedDate: new Date(),
      });
    } catch (e) {
      console.error('error', e);
    }
  };

  useEffect(() => {
    if (student && student?.xapidetails) {
      const xapidetails = JSON.parse(student?.xapidetails as string);
      if (student && xapidetails?.tincan) {
        TinCanService.getInstance(xapidetails);
      }
    }
  }, [student]);

  useEffect(() => {
    setNavDisabled(true);
    return () => setNavDisabled(false);
  });

  return (
    <>
      {!preloader && props.coorectionPage && (
        <div className="fixed inset-0 z-[11] flex bg-white">
          <div className="m-auto">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[110px]"
            />
          </div>
        </div>
      )}
      <CorrectionHeader
        coorectionPage={props.coorectionPage}
        submit={submit}
        isTeacher={props.isTeacher}
        studentId={studentId}
        courseId={courseId}
        lessonId={lessonId}
        course={course}
        student={student}
        lesson={lesson}
        lessonStatus={lessonStatus}
        setPreloaderNext={setPreloaderNext}
        pathnames={pathnames}
      />
      <div className="mt-7">
        <CorrectionContent
          isTeacher={props.isTeacher}
          studentId={studentId}
          courseId={courseId}
          lessonId={lessonId}
          lesson={lesson}
          resaltPage={props.resultPage}
          coorectionPage={props.coorectionPage}
          onSubmit={() => setSubmit(newUid(20))}
          course={course}
          setCourse={setCourse}
          student={student}
          setStudent={setStudent}
          setLesson={setLesson}
          setLessonStatus={setLessonStatus}
          lessonStatus={lessonStatus}
          setPreloader={setPreloader}
          setPreloaderNext={setPreloaderNext}
          preloaderNext={preloaderNext}
        />
      </div>
    </>
  );
};

export default ResultPage;
